import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type StudentOnboardingStep = 'password' | 'avatar' | 'profile' | 'eula' | 'complete';

interface StudentProfileData {
  firstName: string;
  lastName: string;
  phone: string;
  birthdate: string | null;
  avatarUrl: string | null;
}

interface StudentOnboardingStore {
  // Profile data
  profileData: StudentProfileData;
  
  // Onboarding state
  currentStep: StudentOnboardingStep;
  passwordSet: boolean;
  avatarSet: boolean;
  profileComplete: boolean;
  eulaAccepted: boolean;
  
  // Actions
  setProfileData: (data: Partial<StudentProfileData>) => void;
  setCurrentStep: (step: StudentOnboardingStep) => void;
  setPasswordSet: (set: boolean) => void;
  setAvatarSet: (set: boolean) => void;
  setProfileComplete: (complete: boolean) => void;
  setEulaAccepted: (accepted: boolean) => void;
  resetOnboarding: () => void;
}

const initialProfileData: StudentProfileData = {
  firstName: '',
  lastName: '',
  phone: '',
  birthdate: null,
  avatarUrl: null,
};

export const useStudentOnboardingStore = create<StudentOnboardingStore>()(
  persist(
    (set) => ({
      profileData: initialProfileData,
      currentStep: 'password',
      passwordSet: false,
      avatarSet: false,
      profileComplete: false,
      eulaAccepted: false,

      setProfileData: (data) =>
        set((state) => ({
          profileData: { ...state.profileData, ...data },
        })),
      
      setCurrentStep: (step) => set({ currentStep: step }),
      
      setPasswordSet: (value) => set({ passwordSet: value }),
      
      setAvatarSet: (value) => set({ avatarSet: value }),
      
      setProfileComplete: (complete) => set({ profileComplete: complete }),
      
      setEulaAccepted: (accepted) => set({ eulaAccepted: accepted }),
      
      resetOnboarding: () =>
        set({
          profileData: initialProfileData,
          currentStep: 'password',
          passwordSet: false,
          avatarSet: false,
          profileComplete: false,
          eulaAccepted: false,
        }),
    }),
    {
      name: 'rollops-student-onboarding',
    }
  )
);
